import { Doctor } from "../types/appointment.types";
import doc2 from "../assets/Dr.Baldev Singh_medicine.png";
import doc1 from "../assets/DR.R.HARCHANDANI _ surgical specialist.png";
import doc3 from "../assets/dr.mayank shrotriye _ orthopaedics.png";
import doc4 from "../assets/Dr.Pooja Hinduja _ paediatrician, child specialist.png";
import doc10 from "../assets/Dr.Meenakshi  Pandey _ obstetrics and gynaecology.png";
import doc18 from "../assets/Dr_avinash _jhariya_MD_medicine.png";

export const DOCTORS: Doctor[] = [
  {
    id: 1,
    name: "Dr. R. Harchandani",
    degree: "M.S",
    experience: "",
    department: "Surgery",
    image: doc1,
  },
  {
    id: 2,
    name: "Dr. Baldev Singh",
    degree: "MD (Medicine)",
    experience: "15 years",
    department: "General Medicine",
    image: doc2,
  },
  {
    id: 3,
    name: "Dr. Mayank Shrotriya",
    degree: "MBBS, MS",
    experience: "",
    department: "Orthopedics",
    image: doc3,
  },
  {
    id: 4,
    name: "Dr. Pooja Hinduja",
    degree: "MBBS, DNB",
    experience: "",
    department: "Pediatrics",
    image: doc4,
  },
  {
    id: 5,
    name: "Dr. Shivangi Soni",
    degree: "",
    experience: "",
    department: "Physiotherapy",
    image: "",
  },
  {
    id: 6,
    name: "Dr. Abhishek Pandey",
    degree: "BNYS",
    experience: "",
    department: "Naturopathy",
    image: "",
  },
  {
    id: 7,
    name: "Dr. Mansi Dulhani",
    degree: "",
    experience: "",
    department: "Physiotherapy",
    image: "",
  },
  {
    id: 8,
    name: "Dr. Kiran Tiwari",
    degree: "MBBS, BDS",
    experience: "",
    department: "Dental Care",
    image: "",
  },
  {
    id: 9,
    name: "Dr. Tarun Vidhwani",
    degree: "MBBS, DNB",
    experience: "",
    department: "General Medicine",
    image: "",
  },
  {
    id: 10,
    name: "Meenakshi Pandey",
    degree: "MBBS, MS",
    experience: "",
    department: "Gynecology",
    image: doc10,
  },
  {
    id: 11,
    name: "Dr. Suryakant Vardani",
    degree: "Visitor Doctor",
    experience: "",
    department: "General Medicine",
    image: "",
  },
  {
    id: 12,
    name: "Dr. Shailendra Meghwani",
    degree: "Visitor Doctor",
    experience: "",
    department: "General Medicine",
    image: "",
  },
  {
    id: 13,
    name: "Dr. Neha Ram Singhani",
    degree: "Visitor Doctor",
    experience: "",
    department: "Neurology",
    image: "",
  },
  {
    id: 14,
    name: "Dr. Vikram Chavla",
    degree: "Visitor Doctor",
    experience: "",
    department: "General Medicine",
    image: "",
  },
  {
    id: 15,
    name: "Dr. Sangeet Mohan Dwivedi",
    degree: "Duty Doctor",
    experience: "",
    department: "General Medicine",
    image: "",
  },
  {
    id: 16,
    name: "Dr. Pawan Jaiswal",
    degree: "Duty Doctor",
    experience: "",
    department: "General Medicine",
    image: "",
  },
  {
    id: 17,
    name: "Dr. Mahendra Singh",
    degree: "Duty Doctor",
    experience: "",
    department: "General Medicine",
    image: "",
  },
  {
    id: 18,
    name: "Dr. Avinash Jhariya",
    degree: "MD (Medicine)",
    experience: "",
    department: "General Medicine",
    image: doc18,
  },
];
